<template>
	<view class="box">
		<view class="box_textarea">
			<textarea
			placeholder-style="color: #CCCCCC;font-weight: 500;font-size: 28rpx;"
			placeholder="行业对接、商业活动、线下论坛、营销推广、咖啡豆采购等。如有需求请联系我们。"></textarea>
			<view class="box_textarea_list">
				<view class="box_textarea_list_item">
					<image src="@/static/icon/ic_upload@2x.png" mode="widthFix"></image>
				</view>
			</view>
		</view>
		<view class="box_item">
			<text>联系人</text>
			<input type="text" placeholder="填写" placeholder-style="text-align: right;color: #CCCCCC;font-weight: 500;font-size: 28rpx;">
		</view>
		<view class="box_item">
			<text>手机号</text>
			<input type="text" placeholder="填写" placeholder-style="text-align: right;color: #CCCCCC;font-weight: 500;font-size: 28rpx;">
		</view>
		<view class="box_zw"></view>
		<view class="box_footer">
			<view class="box_footer_btn">提交</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style>
	page {
		background-color: #ffffff !important;
	}
</style>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 28rpx 32rpx;
		box-sizing: border-box;
		.box_textarea {
			padding-bottom: 64rpx;
			border-bottom: 2rpx solid #F4F5F4;
			textarea {
				width: 100%;
				height: 204rpx;
				font-size: 28rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #000000;
			}
			.box_textarea_list {
				margin-top: 30rpx;
				width: 100%;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.box_textarea_list_item {
					width: 172rpx;
					height: 172rpx;
					margin-right: 20rpx;
					&:last-child {
						margin: 0 !important;
					}
					image {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
		.box_item {
			width: 100%;
			height: 96rpx;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 2rpx solid #F4F5F4;
			text {
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
			}
			input {
				text-align: right;
				font-size: 28rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #000000;
			}
		}
		.box_zw {
			width: 100%;
			height: calc(112rpx + env(safe-area-inset-bottom));
		}
		.box_footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			box-sizing: border-box;
			background-color: #FFFFFF;
			padding: 20rpx 56rpx calc(20rpx + env(safe-area-inset-bottom)) 56rpx;
			.box_footer_btn {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
		}
	}
</style>